import React, { useState, useEffect, useContext } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Form, Input, Row, Table } from 'antd';
import { useInput } from '../../../../../shared/hooks/useInput';
import { Context } from '../../../../../shared/context/context';
import { ApiApartmentBuildService, ApiApartmentBuildsService } from '../../../../../shared/api';
import { useDrawerVisibility } from '../../../../../shared/hooks/useDrawerVisibility';
import { TableActionColumn } from '../../components/TableActionColumn/TableActionColumn';
import { countText, SectionToolbar, useSectionSearch } from '../../components/SectionToolbar/SectionToolbar';
import { useCanEdit } from '../../../sectionAccess';

const column = [
  { title: 'ID корпуса', dataIndex: 'id', width: 120 },
  { title: 'Название', dataIndex: 'name' },
  { title: 'ID очереди', dataIndex: 'apartmentQueueId', width: 140 },
  {
    title: 'Действия',
    width: 240,
    render: (row) => (
      <TableActionColumn
        onDeleteButtonClick={() => ApiApartmentBuildService.deleteBuild(row.id)}
        payloadOfFieldWhichWillBeUpdated={{ buildIdWhichWillBeUpdated: row.id }}
      />
    ),
  },
];

export const BuildSection = () => {
  const canEdit = useCanEdit();
  const [newBuildInputValue, handleNewBuildInputChange] = useInput('');
  const [queueIdInputValue, handleQueueIdInputValueChange] = useInput('');
  const [setDrawerVisibility] = useDrawerVisibility();
  const { state, dispatch } = useContext(Context);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch, builds] = useSectionSearch(tableData, ['name', 'id', 'apartmentQueueId']);

  const submitNewBuild = () => {
    if (newBuildInputValue.trim() && queueIdInputValue.trim()) {
      ApiApartmentBuildService.createBuild(newBuildInputValue, queueIdInputValue);

      ApiApartmentBuildService.fetchBuilds().then((response) => {
        const sections = response.data;

        sections.forEach((section) => (section.key = section.id));

        setTableData(sections);
      });

      setDrawerVisibility({ buildDrawerVisibility: false });
      dispatch({ type: 'emptyAdminInput' });
    }
  };

  useEffect(() => {
    ApiApartmentBuildsService.fetchAllBuilds().then((response) => {
      const builds = response.data;

      builds.forEach((build) => (build.key = build.id));

      setTableData(builds);
    });
  }, []);

  return (
    <section className="build-section">
      <Table
        title={() => (
          <SectionToolbar
            search={search}
            onSearch={setSearch}
            placeholder='Название корпуса или ID'
            count={countText(tableData.length, builds.length, search)}
          >
            {canEdit && (
              <Button type="primary" icon={<PlusOutlined />} onClick={() => setDrawerVisibility({ buildDrawerVisibility: true })}>
                Добавить корпус
              </Button>
            )}
          </SectionToolbar>
        )}
        columns={canEdit ? column : column.slice(0, -1)}
        dataSource={builds}
        locale={{ emptyText: 'Ничего не нашлось' }}
      />
      <Drawer
        title="Новый корпус"
        width={720}
        onClose={() => setDrawerVisibility({ buildDrawerVisibility: false })}
        visible={state.buildDrawerVisibility}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button onClick={() => setDrawerVisibility({ buildDrawerVisibility: false })} style={{ marginRight: 8 }}>
              Отмена
            </Button>
            <Button onClick={submitNewBuild} type="primary">
              Добавить
            </Button>
          </div>
        }
      >
        <Form layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Input
                onChange={handleNewBuildInputChange}
                placeholder="Название корпуса"
                value={newBuildInputValue}
              />
              <Input
                onChange={handleQueueIdInputValueChange}
                placeholder="ID очереди"
                value={queueIdInputValue}
              />
            </Col>
          </Row>
        </Form>
      </Drawer>
    </section>
  );
};
